import { getList } from "./utils/entity-network-requests"

const entityName = "session"

export const getSessionList = (token, parameters) =>
    getList(entityName, parameters, token)
